"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Camera = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Camera = function Camera(_a) {
  var id = _a.id;
  var clipPathId = id ? "Camera__clip0__".concat(id) : 'Camera__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.292 5.99998H23.4C23.7314 5.99998 24 6.2686 24 6.59998V17.4C24 17.7313 23.7314 18 23.4 18H23.292C22.9772 17.9986 22.6755 17.8737 22.452 17.652L19.2 14.4V18C19.2 19.3255 18.1255 20.4 16.8 20.4H2.4C1.07452 20.4 0 19.3255 0 18V5.99998C0 4.67449 1.07452 3.59998 2.4 3.59998H16.8C18.1255 3.59998 19.2 4.67449 19.2 5.99998V9.59998L22.452 6.34798C22.6755 6.12628 22.9772 6.0013 23.292 5.99998ZM3.59999 10.056C3.59999 10.3873 3.86862 10.656 4.19999 10.656H8.99999C9.33136 10.656 9.59999 10.3873 9.59999 10.056V9.14396C9.59999 8.81259 9.33136 8.54396 8.99999 8.54396H4.19999C3.86862 8.54396 3.59999 8.81259 3.59999 9.14396V10.056Z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "currentColor"
  }))));
};

exports.Camera = Camera;